import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=52c087dc&scoped=true&"
import script from "./Tambah.vue?vue&type=script&lang=js&"
export * from "./Tambah.vue?vue&type=script&lang=js&"
import style0 from "./Tambah.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Tambah.vue?vue&type=style&index=1&id=52c087dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c087dc",
  null
  
)

export default component.exports